"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigpopup = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var BigpopupAction_1 = require("@/pages/common/actions/BigpopupAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var mapStateToProps = function (state) { return state.bigpopup; };
var mapDispatchToProps = function (dispatch) { return ({
    messageClose: function () { return dispatch(BigpopupAction_1.default.messageClose()); },
    onActionClicked: function () { return dispatch(BigpopupAction_1.default.onActionClicked()); },
}); };
exports.bigpopup = function (props) {
    var bigpopClass = classNames([
        'l-fullscreen-dim',
        'l-fullscreen-dim--center',
        'c-bigpopup',
        {
            'l-fullscreen-dim--active': props.active,
            'c-bigpopup--question': props.type === BigPopupState_1.BigPopupType.QUESTION,
            'c-bigpopup--success': props.type === BigPopupState_1.BigPopupType.SUCCESS,
            'c-bigpopup--failed': props.type === BigPopupState_1.BigPopupType.FAILED,
            'c-bigpopup--callPopup': props.type === BigPopupState_1.BigPopupType.CALLPOPUP,
        },
    ]);
    var onBgClicked = function (event) {
        if (event.currentTarget !== event.target)
            return;
        props.messageClose();
    };
    var onActionClicked = function () {
        props.onActionClicked();
        props.messageClose();
    };
    var renderStatusIcon = function () {
        return props.type == BigPopupState_1.BigPopupType.CALLPOPUP ? null : React.createElement("div", { className: "c-bigpopup__status" });
    };
    var renderOfficeHours = function () {
        return props && props.body ? (React.createElement("div", { className: "c-bigpopup--callPopup__body" }, props.body.map(function (officeHour, index) { return (React.createElement("div", { key: index, className: 'c-bigpopup--callPopup__body--section' },
            React.createElement("label", null, officeHour.day),
            React.createElement("label", null, officeHour.time),
            React.createElement("div", { className: "c-bigpopup--callPopup__empty-row" }))); }))) : null;
    };
    var renderActionButton = function () {
        return props.type == BigPopupState_1.BigPopupType.CALLPOPUP ? null : (React.createElement("div", { className: "c-bigpopup__action" },
            React.createElement("button", { onClick: onActionClicked, className: "o-btn o-btn--primary u-md", id: "bigpopup-confirm" }, props.type === BigPopupState_1.BigPopupType.FAILED ? props.actionFailed : props.action)));
    };
    var renderTitle = function () {
        return (React.createElement("div", { className: "" + (props.type === BigPopupState_1.BigPopupType.CALLPOPUP ? 'c-bigpopup--callPopup__title' : 'c-bigpopup__title') },
            React.createElement("span", { className: (props.type === BigPopupState_1.BigPopupType.CALLPOPUP ? 'c-bigpopup--callPopup__callicon fal fa-phone' : '') + " " }),
            React.createElement("span", null, props.title)));
    };
    var renderCaption = function () {
        return (React.createElement("div", { className: "" + (props.type === BigPopupState_1.BigPopupType.CALLPOPUP ? 'c-bigpopup--callPopup__caption' : 'c-bigpopup__caption') },
            React.createElement("span", null, props.caption)));
    };
    var id = props.id ? "bigpopupsection_" + props.id : 'bigpopupsection';
    return props.active ? (React.createElement("div", { onClick: onBgClicked, id: id, className: bigpopClass },
        React.createElement("div", { className: "" + (props.type === BigPopupState_1.BigPopupType.CALLPOPUP ? 'c-bigpopup--callPopup__main' : 'c-bigpopup__main') },
            React.createElement("div", { className: "" + (props.type === BigPopupState_1.BigPopupType.CALLPOPUP ? 'c-bigpopup--callPopup__close' : 'c-bigpopup__close'), onClick: props.messageClose },
                React.createElement("span", { className: "fal fa-times" })),
            React.createElement("div", { className: "" + (props.type === BigPopupState_1.BigPopupType.CALLPOPUP ? 'c-bigpopup--callPopup__body' : 'c-bigpopup__body') },
                renderStatusIcon(),
                renderTitle(),
                renderCaption(),
                renderOfficeHours(),
                renderActionButton())))) : null;
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.bigpopup);
